import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tooltip } from 'reactstrap';
import ToggleSwitch from "../common/input/ToggleSwitch";
import * as types from "../../constants/actionTypes";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import SectionLoading from "../common/SectionLoading";
import SectionLoadingError from "../common/SectionLoadingError";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import GeneralNotifications from "./GeneralNotifications";
import HealthPlanNotifications from "./HealthPlanNotifications";

const pharmacyNotification = "PharmacyNotification";

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.state = {
            UseEmail: false, UseSms: false, Phone: null, Email: null,
            showToolTip: false, alreadySet: false, useSmsChanging: false, useEmailChanging: false
        };
    }

    componentDidMount() {
        const { userName, getUserNotificationPreference } = this.props;
        this.setState({ alreadySet: false });
        getUserNotificationPreference(userName);
        logUI("MBHWeb.UI.Notifications.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate() {
        const { useSmsChanging, useEmailChanging, alreadySet } = this.state;
        const { rxNotificationUpdate, notificationData } = this.props;
        const error = rxNotificationUpdate && rxNotificationUpdate.error ? rxNotificationUpdate.error : null;

        const notificationPreferenceData = notificationData && !notificationData.waiting && notificationData.response && notificationData.response.length > 0 ? notificationData.response : [];
        if (!alreadySet) {
            for (let data of notificationPreferenceData) {
                if (data.EventName === pharmacyNotification) {
                    const { UseEmail, UseSms, Phone, Email } = data;
                    this.setState({ alreadySet: true, UseEmail, UseSms, Phone, Email });
                    break;
                }
            }
        }
        if (useSmsChanging && error) {
            this.setState({ useSmsChanging: false, UseSms: !this.state.UseSms });
        }
        else if (useEmailChanging && error) {
            this.setState({ useEmailChanging: false, UseEmail: !this.state.UseEmail });
        }
    }

    onRxSmsNotificationChange(UseSms) {
        const { userName, savePharmacyNotificationPreference } = this.props;
        const { UseEmail, UsePush } = this.state;
        this.setState({ useSmsChanging: true, UseSms });
        savePharmacyNotificationPreference(userName, UseEmail, UseSms, UsePush, pharmacyNotification);
    }

    onRxEmailNotificationChange(UseEmail) {
        const { userName, savePharmacyNotificationPreference } = this.props;
        const { UseSms, UsePush } = this.state;
        this.setState({ useEmailChanging: true, UseEmail });
        savePharmacyNotificationPreference(userName, UseEmail, UseSms, UsePush, pharmacyNotification);
    }
    formattedPhone(phone) {
        return `${phone.AreaCode}.${phone.PhoneNumber.substr(0, 3)}.${phone.PhoneNumber.substr(3)}`;
    }

    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }


    render() {
        const { serverData, rxDown, hasPharmacyLogin, hasMyChart, rxNotificationUpdate, isProxyUser, epicEHRDown, notificationData, bffDashboardData, currentUser, hasSWHP, hasFirstCare, insuranceName, isMyChartInActive } = this.props;
        const { UseEmail, UseSms, Phone, Email, showToolTip } = this.state;

        return (
            <div className="container-fluid body-content notifications-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">

                        <div className="row page-heading-container--dt">
                            <div className="col-12">
                                <h1 className="page-heading">Notifications</h1>
                            </div>
                        </div>
                        {serverData.enableGeneralNotification && <GeneralNotifications />}
                    
                {!isProxyUser && <React.Fragment>
                    <div className="row">
                        <div className="col-12">
                            <h2 className="page-heading section-heading">Pharmacy</h2>
                        </div>
                    </div>
                    {!rxDown
                        ? <React.Fragment>
                            {hasPharmacyLogin
                                ? <React.Fragment>
                                    {typeof notificationData === 'undefined' || notificationData.waiting
                                        ? <SectionLoading />
                                        : notificationData.error
                                            ? <SectionLoadingError message="We're sorry, we currently are unable to get your pharmacy notification preference." />
                                            : <React.Fragment>
                                                <div className="row">
                                                    <div className="col-12 list-item-col not-linked">
                                                        <div className="row">
                                                            <div className="col-12 col-md-6 col-lg-4 list-item-col__data">
                                                                <div className="list-item-col__label">Mobile Phone: </div>
                                                                <div className="list-item-col__info">{Phone ? this.formattedPhone(Phone) : 'None entered'}</div>
                                                            </div>
                                                            <div className="col-12 col-md-6 col-lg-4 list-item-col__data">
                                                                <div className="list-item-col__label">Email: </div>
                                                                <div className="list-item-col__info">{Email ? Email : 'None entered'}</div>
                                                            </div>
                                                            <div className="col-12 col-lg-4 text-lg-right">
                                                                <Link to="/demographics">Edit in your profile</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-12 list-item-col not-linked">
                                                        <div className="row">
                                                                <div className="col-12 col-lg-8 col-md-6">
                                                                <div className="list-item-col__label">Prescriptions <span className="icon-info" id="lbl-rx" />
                                                                    <Tooltip className="notification-tool-tip" placement="top" isOpen={showToolTip} autohide={false} target="lbl-rx" toggle={this.toggleTooltip}>
                                                                        Be notified when they’re ready to refill and/or pickup.
                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 col-lg-2 col-md-3 text-sm-right">
                                                                <ToggleSwitch placeholder="TEXT" name="textNotifications"
                                                                    checked={UseSms}
                                                                    onChange={checked => this.onRxSmsNotificationChange(checked)}
                                                                />
                                                            </div>
                                                            <div className="col-6 col-lg-2 col-md-3 text-sm-right">
                                                                <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                                                    checked={UseEmail}
                                                                    onChange={checked => this.onRxEmailNotificationChange(checked)}
                                                                />
                                                            </div>
                                                            <div className="col-12">
                                                                {rxNotificationUpdate &&
                                                                    <div>
                                                                        {rxNotificationUpdate.waiting
                                                                            ? <SectionLoading />
                                                                            : rxNotificationUpdate.error
                                                                                ? <SectionLoadingError message="We're sorry, we currently are unable to change your pharmacy notification preference." />
                                                                                : rxNotificationUpdate.response && <span className="success-msg">Your change has been successfully saved.</span>
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-12 list-item-col not-linked">
                                                        <div className="row">
                                                            <div className="col-12 col-sm-4 col-md-3">
                                                                <div className="list-item-col__label">Push</div>
                                                            </div>
                                                            <div className="col-12 col-sm-8 col-md-9 text-left text-sm-right">
                                                                <div className="list-item-col__info">Manage in MyBSWHealth mobile app.</div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                    }


                                </React.Fragment>
                                : <div>
                                    You haven’t linked a BSWH pharmacy account yet. You can do this {' '}
                                    <Link to={{ pathname: '/linkedAccounts' }}>here</Link>.
                                </div>
                            }
                        </React.Fragment>
                        : <SectionLoadingError message="Not available. Please try again later." />
                    }
                </React.Fragment>
                }
               
               
                        {(hasSWHP || hasFirstCare) && serverData && serverData.enableNewHealthPlan && !isProxyUser &&
                            <div className="health-plan-notifications">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="page-heading section-heading">{
                                        `${ insuranceName ? insuranceName : hasFirstCare ? "FirstCare Health Plans" : "Baylor Scott & White Health Plan"}`}
                                        </h2>
                                    </div>
                                </div>
                                <div>You can manage your notifications <Link to={{ pathname: '/preferenceSettings' }}>here</Link>.</div>
                            </div>
                            /*<HealthPlanNotifications userRole={hasSWHP ? "SWHP" : "FirstCare"} /> */
                }    
                {hasMyChart &&
                    <React.Fragment>
                        <div className="row">
                            <div className="col-8 col-md-10">
                                <h2 className="page-heading section-heading dt-heading">Medical Records</h2>
                            </div>
                        </div>
                        {!epicEHRDown && !isMyChartInActive ?
                            <MyChartDataTile mode="patprefs" title="Medical Records Notifications" navigation="hide" serverData={serverData} partialView />
                            :
                            <SectionLoadingError sectionErrorClass="errorSectionClass" message="Not available. Please try again later." />
                        }
                    </React.Fragment>
                }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        hasMyChart: state.domain.hm,
        serverData: state.session.serverData,
        userName: state.domain.un,
        isProxyUser: state.domain.ip,
        rxNotificationUpdate: state.common[types.PHARMACY_NOTIFICATION_PREFERENCE_SAVE],
        epicEHRDown: state.common.epicEHRDown,
        notificationData: state.common[types.GET_USER_NOTIFICATION_PREFERENCE],
        bffDashboardData: state.dashboard.bffDashboardData,
        currentUser: state.memberships.currentUser,
        hasSWHP: state.memberships.hasAnySWHP,
        hasFirstCare: state.memberships.hasFC,
        insuranceName: state.session.insuranceName,
        isMyChartInActive: state.dashboard.isMyChartInActive
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserNotificationPreference: (userName) => dispatch({ type: types.GET_USER_NOTIFICATION_PREFERENCE, data: userName }),
        savePharmacyNotificationPreference: (userName, useEmail, useSms, usePush, eventName) =>
            dispatch({ type: types.PHARMACY_NOTIFICATION_PREFERENCE_SAVE, data: { userName, useEmail, useSms, usePush, eventName } })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);